import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/global/Header";
import Footer from "./components/global/Footer";
import { Container } from "@mui/system";

export default function PublicAuth() {
  return (
    <div className="bg-gray-100">
      <div className="w-full">
        <Header />
      </div>
      <div className="w-full">
        <div className="min-h-[90vh] p-4 text-white">
          <Container maxWidth="xl" sx={{ p: 2, height: "100%" }}>
            {<Outlet />}
          </Container>
        </div>
      </div>
      <Footer />
    </div>
  );
}
